module.exports={render:function (){with(this) {
  return (viewLabel) ? _h('label', {
    staticClass: "ion-label",
    class: ['label-' + theme, aColor]
  }, [_t("default")]) : _e()
}},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-573656f0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/label/src/label.vue
// module id = 159
// module chunks = 0